import { EventEmitter, Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SignalRService {
  public connectionId: string;

    private hubConnection: signalR.HubConnection;
    public messageReceived: EventEmitter<{ user: string, message: string }> = new EventEmitter<{ user: string, message: string }>();

    constructor() { }

    startConnection = () => {
      this.hubConnection = new signalR.HubConnectionBuilder()
          .withUrl(`${environment.signalRUrl}/userHub`)
          .build();

      this.hubConnection
          .start()
          .then(() => console.log('SignalR connection started'))
          .then(()=>this.getConnectionId())          
          .catch(err => console.error('Error while starting connection: ', err));

      // Subscribe to ReceiveMessage event to handle incoming messages
      this.hubConnection.on('ReceiveMessage', (user: string, message: string) => {
          // Emit the received message through the event emitter
          this.messageReceived.emit({ user, message });
      });
  }

  sendMessage = (message: string) => {
      this.hubConnection.invoke('Send',  message)
          .catch(err => console.error(err));
  }

  private getConnectionId = () => {
    this.hubConnection.invoke('getconnectionid')
    .then((data) => {
      this.connectionId = data;
      this.sendMessage("testmessage");
    });
  }
}
